import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SystemApiService } from '@cv-invision/core';

@Injectable()
export class AcuityService {

	private readonly BASE_URL = '/utils';

	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {
	}

	/**
	 * GET - Return the list of the loan types configuration mappings.
	 */
	getLoanTypes(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/acuity/loan-types`);
	}

	/**
	 * GET - Return the list of the loan reasons configuration mappings.
	 */
	getLoanReasons(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/acuity/loan-reasons`);
	}

	/**
	 * GET - Return the list of available acuity property types
	 */
	getPropertyTypes(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/acuity/property-types`);
	}

	/**
	 * GET - Return the list of available occupancy types
	 */
	getOccupancyTypes(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/acuity/occupancy-types`);
	}

	/**
	 * GET - Return the list of available occupancy types
	 */
	getDocumentTypes(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/acuity/occupancy-types`);
	}
}
